import { render, staticRenderFns } from "./TickerStat.vue?vue&type=template&id=082deb1b&scoped=true"
import script from "./TickerStat.vue?vue&type=script&lang=js"
export * from "./TickerStat.vue?vue&type=script&lang=js"
import style0 from "./TickerStat.vue?vue&type=style&index=0&id=082deb1b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082deb1b",
  null
  
)

export default component.exports